import jwt_decode from 'jwt-decode';
import {
  SET_USER,
  SET_USER_LOGGED,
  SET_REPRESENTED_ID,
  SET_REPRESENTED,
  SET_USER_ACCESS,
  SET_USER_LOGGED_IN_TOKEN,
  SET_REPRESENTS,
  SET_USER_VALID
} from '../actions/actionTypes';

const initialState = {
  user: {
    userCpf: '',
    userEmail: '',
    userLogin: '',
    userName: '',
    userPhone: '',
    userType: '',
    token: '',
    roles: ['']
  },
  represented: {
    representedCpfCnpj: '',
    representedName: '',
    representedId: -1,
  },
  represents: [],
  userLogged: false,
  acesso: false
};

const setUserByToken = (state, token) => {
  if (token) {
    const infosUser = jwt_decode(token);
    return {
      userCpf: infosUser.cpfcnpj,
      userEmail: infosUser.email,
      userLogin: infosUser.usr,
      userName: infosUser.name,
      userType: infosUser.tu,
      token: token,
      roles: infosUser.roles || ['']
    };
  }
  return state.user;
};

const setRepresentedId = (state, representedId) => {
  return {
      ...state.user.represented,
      representedId: representedId
    }
};

const setRepresented = (state, represented) => {
  if (represented) {
    return {
      representedCpfCnpj: represented.id > 1 ? represented.id : '',
      representedName: represented.nome,
      representedId: represented.id
    }
  }
  return state.represented;
};

const setRepresents = (represents) => {
  if (represents && represents.length > 0) {
    return represents
  }
}

export const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_USER:
      return {
        ...state,
        user: action.newValue
      };

    case SET_USER_LOGGED:
      return {
        ...state,
        userLogged: action.newValue
      };

    case SET_REPRESENTED_ID:
      return {
        ...state,
        represented: setRepresentedId(state, action.newValue)
      };

    case SET_REPRESENTED:
      return {
        ...state,
        represented: setRepresented(state, action.newValue)
      };

    case SET_REPRESENTS:
      return {
        ...state,
        represents: setRepresents(action.newValue)
      };

    case SET_USER_ACCESS:
      return {
        ...state,
        acesso: action.newValue
      };

    case SET_USER_LOGGED_IN_TOKEN:
      return {
        ...state,
        user: setUserByToken(state, action.newValue)
      };
      
    default:
      return state;
  }
};
